import { ArrowBackIos } from '@mui/icons-material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useAppSelector } from 'app/hooks';
import Row, { RowItem } from 'blocks/Row';

import { Link } from 'react-router-dom';
import { isLTRState } from 'store/options/optionsSlice';
import { BreadcrumbProps } from './bread.interface';
import * as S from './breadcrumb.styles';

const Breadcrumb = ({ links, title }: BreadcrumbProps) => {
  const isLTR = useAppSelector(isLTRState);
  return (
    <S.Wrapper>
      <Row align="center">
        {links.map((link, index) => (
          <S.WrapperLink as={RowItem} flex={false} key={index}>
            {link.url ? (
              <S.WrapperLinkName as={Link} $isActive={link.active} to={link.url}>
                {link.title}
              </S.WrapperLinkName>
            ) : (
              <S.WrapperLinkName $isActive={link.active}>{link.title}</S.WrapperLinkName>
            )}

            {index !== links.length - 1 &&
              (isLTR ? <S.WrapperLinkSvg as={ArrowForwardIosIcon} /> : <S.WrapperLinkSvg as={ArrowBackIos} />)}
          </S.WrapperLink>
        ))}
      </Row>
      {title ? <S.PageTitle className="page-title mb-sm">{title}</S.PageTitle> : null}
    </S.Wrapper>
  );
};

export default Breadcrumb;
